module.exports = __webpack_public_path__ + "static/octin-stencil-rg-subset-3ee454dc6c55db851011930dd1c820e2.woff2";